import { NgClass, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { IconName } from '@sc/data-access-assets';
import { LoggerLevelType } from '@sc/data-access-models';
import { IconComponent } from '@sc/ui-components';
import { SnackbarBottomData } from '../../types/snackbar-data';

@Component({
  selector: 'sc-snackbar-bottom',
  styleUrls: ['./snackbar-bottom.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgClass, IconComponent, TranslateModule],
  template: `
    <div
      class="content"
      [ngClass]="{
        warning: data?.type === 'WARNING',
        success: data?.type === 'SUCCESS',
        info: data?.type === 'INFO',
        error: data?.type === 'ERROR'
      }"
      *ngIf="!!data"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="sc-bottom-snackbar-title"
      aria-describedby="sc-bottom-snackbar-body"
    >
      <div class="notification-color"></div>
      <section>
        <div class="right">
          <div class="top">
            <div id="sc-bottom-snackbar-title" class="title hide-focus-outline">
              <sc-icon [name]="iconToDisplay"></sc-icon>
              <p role="heading" et aria-level="1" tabindex="-1">
                {{ data.title }}
              </p>
            </div>
          </div>
          <div id="sc-bottom-snackbar-body" class="msg">
            <p>{{ data.message }}</p>
          </div>
        </div>

        <button class="left" type="button" (click)="onCloseClick()">
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeSnackbar' | translate
          }}</span>
          <sc-icon name="close"></sc-icon>
        </button>
      </section>
    </div>
  `,
})
export class SnackbarBottomComponent {
  iconToDisplay: IconName = 'check';
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarBottomData) {
    this.iconToDisplay =
      data?.type === LoggerLevelType.ERROR
        ? 'close'
        : data?.type === LoggerLevelType.INFO
        ? 'info'
        : data?.type === LoggerLevelType.WARNING
        ? 'alert'
        : 'check';
  }

  @HostListener('document:keydown.escape')
  onCloseClick(): void {
    this.data.currentSnackBar.dismiss();
  }
}
